/* Mesmerize · Tungsten PDP · mes-ring-3d.js (loaded deferred by sections/mes-pdp3-ring-3d.liquid only)
   Port of the Website 3.0 design's ring-viewer.js in its "minimal" (hero) mode: no poster, no "Drop it", no colour UI.
   PERF CHANGE FROM THE DESIGN (deliberate): the design auto-loads three.js + the GLB as soon as the hero is idle on screen.
   Here NOTHING 3D loads until the shopper taps the pill: then assets/mes-three-ring.min.js (self-hosted three r165,
   A651) and the ring's GLB are fetched, the viewer fades in over the current gallery photo, and "View photo" fades back
   and disposes everything (WebGL context included). Render loop only while open, on screen and the tab is visible; it
   also stops once the ring has settled after a drag. DPR capped at 1.75. Reduced motion: no idle spin, no fall-in.
   Tint follows the selected colour option (theme event `variant:change`, detail.variant.options).
   AUTO MODE (V9.28.185, Shrey A1198 = 1A): data-auto "capable" (default) / "all" / "tap". The photo stays the first
   paint; after window load + data-auto-delay + an idle slot, and once the gallery is half on screen, the bundle and GLB
   load with the viewer still HIDDEN, and only a ready, rendered ring fades in (no loading state over the photo).
   "capable" skips low-end devices (deviceMemory <= 4 GB or <= 4 cores, the same rule as the lead video and the
   'video_eligible' A/B segment); every mode skips Data Saver, reduced motion and the theme editor, and steps aside when
   the lead video is playing on that photo. Once the shopper taps the button, auto never fires again on that page.
   Moving the carousel to another photo (dots, thumbnails) closes the 3D, auto or tapped. */
(function () {
  'use strict';
  if (window.__mesRing3d) return; window.__mesRing3d = true;

  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  /* Metal palette, verbatim from ring-viewer.js applyTint(): [linear RGB, roughness]. */
  /* V9.28.198 (Shrey 14 Oct: "gold and rose gold look extremely washed out"): matched to the PRODUCT PHOTOS, not the Blender
     stills (Blender's AgX turns the real rich yellow gold into pale champagne). Linear RGB, colour only (roughness stays the
     GLB's own). silver / black: Walt's fit (V9.28.196). */
  var PAL = { gold: [1.0, 0.71, 0.29], silver: [0.49, 0.51, 0.55], rose: [0.91, 0.53, 0.40], black: [0.022, 0.022, 0.022] }; /* V9.28.204 (Shrey 14 Oct, H577): black is neutral and darker, no blue cast */
  /* V9.28.201 (H573 r2, Walt's lab): per-ring exposure under Neutral (= env intensity, env-only lighting), fitted to the product
     photos + Shubham's stills (photo dE 17.95 -> 15.58). nrm:0 drops a lossy-WebP normal map (hammered-dual: its facets are
     geometry). Remove nrm and the normal cap after a lossless GLB re-export (Shubham). Unknown files: 1.4. */
  var LOOK = {
    'blue-streak': { exp: 1.3, rough: { Matte_Band_Left: 0.50, Matte_Band_Right: 0.48, '*': 0.125 }, mat: { Centre_Polished_Groove: [0.03, 0.18, 0.48], Inner_Surface: [0.03, 0.18, 0.48] } }, /* V9.28.210 (Shrey option B, H584): blue parts only, by material name */ 'forged': { exp: 1.6, nrm: 0, metal: { gold: 1.6, rose: 1.1, silver: 1.4, black: 1.4 }, pal: { rose: [0.42, 0.28, 0.20] } }, /* V9.28.206 (Shrey, H581): forged's rose is the real ring's deep chocolate bronze */
    'gold-in-silver': { exp: 1.6 }, 'gold-inlay': { exp: 1.4 }, 'gold-on-gold': { exp: 1.2 }, 'gold-streak': { exp: 1.2 },
    'gunmetal-gold': { exp: 1.6 }, 'hammered-dual': { exp: 1.3, nrm: 0, mat: { Polished_Gold_Tracks: [0.85, 0.55, 0.15], Gold_Comfort_Interior: [0.85, 0.55, 0.15] } }, /* V9.28.212 (Shrey option B, H587) */ 'multi': { exp: 1.2, body: [1.0, 0.66, 0.16], logoEdge: [0.70, 0.95] }, /* V9.28.209 (H583): decal background min channel is 0.54, letters 0.98+ */ /* V9.28.207 (Shrey option B, H582): untinted ring, body colour override */ 'silver-on-blue': { exp: 1.4, mat: { 'Polished_Gold_Tracks.006': [0.03, 0.18, 0.48], 'Polished_Silver_Interior.007': [0.03, 0.18, 0.48] } }, /* V9.28.213 (Shrey option C, H588): blue-streak's blue */
    'silver-streak': { exp: 1.4 }, 'vulcan': { exp: 1.2, metal: { gold: 1.2, rose: 1.6, silver: 1.4, black: 1.4 } }
  };
  function lookOf(src) { var m = /mes-ring-([a-z0-9-]+)\.glb/i.exec(String(src || '')); return (m && LOOK[m[1].toLowerCase()]) || { exp: 1.4 }; }

  /* One shared, retrying load of the bundle for every 3D section on the page (the comfort cutaways use the same one). */
  function three(url) {
    if (!window.__mesThreeRing) window.__mesThreeRing = window.__mesImport(url).catch(function (e) { window.__mesThreeRing = null; throw e; });
    return window.__mesThreeRing;
  }
  function json(el, sel, fb) { var s = el.querySelector(sel); if (!s) return fb; try { return JSON.parse(s.textContent); } catch (e) { return fb; } }

  /* "Gold:gold, Rose Gold:rose" -> [['rose gold','rose'], ['gold','gold']], longest name first so "Rose Gold" wins over "Gold". */
  function parseMap(txt) {
    var out = [];
    String(txt || '').split(/[,\n]/).forEach(function (pair) {
      var i = pair.lastIndexOf(':'); if (i < 1) return;
      var k = pair.slice(0, i).trim().toLowerCase(), v = pair.slice(i + 1).trim().toLowerCase();
      if (k && v in PAL) out.push([k, v]);
    });
    return out.sort(function (a, b) { return b[0].length - a[0].length; });
  }
  function metalOf(map, options) {
    var vals = (options || []).map(function (o) { return String(o == null ? '' : o).trim().toLowerCase(); });
    for (var i = 0; i < vals.length; i++) for (var j = 0; j < map.length; j++) if (vals[i] === map[j][0]) return map[j][1];
    for (i = 0; i < vals.length; i++) for (j = 0; j < map.length; j++) if (vals[i].indexOf(map[j][0]) > -1) return map[j][1];
    return null;
  }

  function init(root) {
    if (root._r3d) return; root._r3d = true;
    var models = json(root, '[data-r3d-models]', []), state = json(root, '[data-r3d-state]', {});
    if (!models.length) return;
    var pill = root.querySelector('[data-r3d-pill]'), pillTxt = root.querySelector('[data-r3d-pill-t]');
    var layer = root.querySelector('[data-r3d-layer]'), stage = root.querySelector('[data-r3d-stage]'), note = root.querySelector('[data-r3d-note]');
    var A = function (n, fb) { var v = root.getAttribute('data-' + n); return v == null || v === '' ? fb : v; };
    var L = { on: A('l-on', ''), off: A('l-off', ''), loading: A('l-loading', ''), retry: A('l-retry', '') };
    var FADE = parseInt(A('fade', '600'), 10) || 600, IDLE = (parseFloat(A('spin', '6')) || 0) / 1000;
    var map = parseMap(A('map', ''));
    var metal = metalOf(map, state.options), alt = state.alt || '';

    /* Gallery host: the main product carousel wrapper (same element the 3D kada uses); else an inline box in the section. */
    var host = null, sel = A('host', '');
    try { host = sel ? document.querySelector(sel) : null; } catch (e) { host = null; }
    if (host) {
      host.classList.add('mes-r3d-host');
      host.appendChild(layer); host.appendChild(pill);
      root.classList.add('is-moved');
    } else {
      host = root.querySelector('[data-r3d-inline]');
      root.classList.add('is-inline');
    }
    pill.hidden = false;

    function pick() { /* product-media models: the one whose alt matches the variant photo (V9.28.91 rule), else the first */
      for (var i = 0; i < models.length; i++) if (models[i].alt && alt && models[i].alt === alt) return models[i];
      return models[0];
    }
    var model = pick();

    /* Cover the photo the shopper is looking at: the slide that overlaps the gallery box most. (The swipe carousel sets
       no "selected" class on its slides, so the old is-selected lookup fell back to slide 1, which after a swipe sits a
       full width off screen: the viewer opened out of sight. Priyanka, H542 retest, 13 Oct.) */
    function current(hr) {
      var best = null, bestA = 0, list = host.querySelectorAll('.product-gallery__media:not([hidden])');
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        var a = Math.max(0, Math.min(r.right, hr.right) - Math.max(r.left, hr.left)) * Math.max(0, Math.min(r.bottom, hr.bottom) - Math.max(r.top, hr.top));
        if (a > bestA) { bestA = a; best = list[i]; }
      }
      return best;
    }
    function place() {
      if (root.classList.contains('is-inline')) return;
      var hr = host.getBoundingClientRect(), m = current(hr);
      atSlide = m;
      if (!m) { layer.style.cssText = ''; return; }
      var mr = m.getBoundingClientRect();
      /* never past the SCREEN edges: nothing above clips the layer, so a layer placed mid-swipe widened the whole page
         (Priyanka 13 Oct, "extra space after scrolling"; measured: layer +120px = page 360 -> 500px wide). Clamped to the
         screen, not the gallery box: phone slides bleed past the box to the screen edges and the 3D must cover them. */
      var vw = document.documentElement.clientWidth, w = Math.min(mr.width, vw);
      var x = Math.max(-hr.left, Math.min(mr.left - hr.left, vw - hr.left - w));
      layer.style.left = x + 'px'; layer.style.top = (mr.top - hr.top) + 'px';
      layer.style.width = w + 'px'; layer.style.height = mr.height + 'px'; layer.style.right = 'auto'; layer.style.bottom = 'auto';
    }

    var open = false, v = null, building = null, raf = 0, shown = false, closeT = 0, hostRO = null;
    var pendingAuto = false, userTook = false, atSlide = null;
    function label(t) { pillTxt.textContent = t; }
    function setNote(t) { note.textContent = t || ''; note.hidden = !t; }

    /* ---------- the viewer (port of RingViewer.load / fetchModel / studio / frame) ---------- */
    /* V9.28.196 (H573): procedural black-and-white studio for the REFLECTIONS, from Walt's lab fitted to Shubham's Cycles
       references (mean sRGB difference 85.3 -> 17.7 over 12 rings x 3 views). 0 KB, no HDRI (Shrey A1225 = 1B): one sphere +
       a 256x128 canvas. Grey ceiling, black floor, dark horizon, wide key band left, fill right-behind, two 3x5 softbox grids.
       Never visible: it only feeds the PMREM. Source: handover/website3-ring-pdp-3d/lab/. */
    /* The studio's pixels (~63 ms in one go at 4x CPU throttle, measured 14 Oct) are drawn in 8 slices of 16 rows with a
       yield between them, so a tap is never stuck behind the whole draw; cached for the page, so later opens reuse them. */
    var STUDIO_W = 256, STUDIO_H = 128, STUDIO_MAX = 2.4;
    function studioPixels(sliced) { /* sliced only for the auto fade-in; a tap (the shopper is waiting) or a hidden tab (timers throttled to ~1 s) draws it at once */
      if (window.__mesStudioPx) return window.__mesStudioPx;
      var W = STUDIO_W, H = STUDIO_H, MAX = STUDIO_MAX;                                /* canvas holds radiance / MAX, sRGB 8-bit */
      var SKY = 0.295, SKY_LO = 17, SKY_HI = 32;                                     /* ceiling grey, fades in 17..32 deg up */
      var RECTS = [[-87, 10, 132, 30, 2.28, 3], [120, 9, 36, 34, 1.2, 5]];           /* [az, el, width, height, radiance, soft deg]: key band, fill */
      var GRIDS = [[0, 27, 21, 10, 1.85], [164, 27, 21, 10, 2.4]];                   /* [centre az, column pitch, w, h, radiance]: 3 cols x 5 rows, rows every 20 deg */
      function sm(a, b, x) { var t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); }
      function mask(az, el, raz, rel, w, h, s) {
        var da = Math.abs(az - raz); if (da > 180) da = 360 - da;
        return (1 - sm(w / 2 - s, w / 2 + s, da)) * (1 - sm(h / 2 - s, h / 2 + s, Math.abs(el - rel)));
      }
      var px = new Uint8ClampedArray(W * H * 4), D = 180 / Math.PI;
      function rows(j0, j1) { for (var j = j0; j < j1; j++) {
        var el = 90 - (j + 0.5) / H * 180;                                           /* SphereGeometry: canvas row 0 = straight up */
        for (var i = 0; i < W; i++) {
          var ph = (i + 0.5) / W * 2 * Math.PI, az = Math.atan2(-Math.cos(ph), Math.sin(ph)) * D;
          var v = el > 0 ? SKY * sm(SKY_LO, SKY_HI, el) : 0, m, k, a, b;
          for (k = 0; k < RECTS.length; k++) { var R = RECTS[k]; m = mask(az, el, R[0], R[1], R[2], R[3], R[5]); if (m > 0) v += (R[4] - v) * m; }
          for (k = 0; k < GRIDS.length; k++) { var G = GRIDS[k];
            for (a = -1; a <= 1; a++) for (b = -2; b <= 2; b++) { m = mask(az, el, G[0] + a * G[1], b * 20, G[2], G[3], 3); if (m > 0) v += (G[4] - v) * m; } }
          var x = Math.min(1, v / MAX), s = x <= 0.0031308 ? x * 12.92 : 1.055 * Math.pow(x, 1 / 2.4) - 0.055, o = (j * W + i) * 4;
          px[o] = px[o + 1] = px[o + 2] = Math.round(s * 255); px[o + 3] = 255;
        }
      } }
      window.__mesStudioPx = new Promise(function (res) {
        var j = 0;
        if (!sliced) { rows(0, H); res(px); return; }
        (function slice() { rows(j, Math.min(H, j + 16)); j += 16; if (j < H && !document.hidden) { setTimeout(slice, 0); } else { rows(j, H); res(px); } })();
      });
      return window.__mesStudioPx;
    }
    function studio(T, px) {
      var W = STUDIO_W, H = STUDIO_H, MAX = STUDIO_MAX;
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var g = c.getContext('2d'), img = g.createImageData(W, H); img.data.set(px); g.putImageData(img, 0, 0);
      var tex = new T.CanvasTexture(c); tex.colorSpace = T.SRGBColorSpace;
      var sc = new T.Scene();
      var mat = new T.MeshBasicMaterial({ map: tex, side: 1 /* BackSide */ }); mat.color.setScalar(MAX);
      sc.add(new T.Mesh(new T.SphereGeometry(10, 64, 32), mat));
      return sc;
    }
    function freeTree(obj) {
      obj.traverse(function (o) {
        if (o.geometry) o.geometry.dispose();
        if (o.material) [].concat(o.material).forEach(function (m) { Object.keys(m).forEach(function (k) { var x = m[k]; if (x && x.isTexture) x.dispose(); }); m.dispose(); });
      });
    }
    function fetchModel(T, loader, src) {
      return loader.loadAsync(new URL(src, document.baseURI).href).then(function (gltf) {
        var ring = gltf.scene;
        /* normalise: centre, scale the ring's face to 1.6 units, turn its axis (thinnest side) towards the camera */
        var bx = new T.Box3().setFromObject(ring), size = bx.getSize(new T.Vector3()), ctr = bx.getCenter(new T.Vector3());
        var thin = size.x < size.y && size.x < size.z ? 'x' : size.y < size.z ? 'y' : 'z';
        var face = thin === 'x' ? Math.max(size.y, size.z) : thin === 'y' ? Math.max(size.x, size.z) : Math.max(size.x, size.y);
        ring.position.sub(ctr); var k = 1.6 / face; ring.scale.multiplyScalar(k); ring.position.multiplyScalar(k);
        var g = new T.Group(); g.add(ring);
        if (thin === 'y') g.rotation.x = Math.PI / 2; else if (thin === 'x') g.rotation.y = Math.PI / 2;
        /* body materials = everything except the logo; tinting only touches these */
        var body = [], logos = [], lk = lookOf(src);
        ring.traverse(function (o) {
          if (!o.isMesh) return;
          [].concat(o.material).forEach(function (m) { if (m.anisotropy) { m.anisotropy = 0; } /* forged: GLB anisotropy follows UV tangents, not the ring, and smeared the reflections */ 
            /* V9.28.201 (H573 r2): the normal maps are lossy WebP and the streak rings use strength 8.9, which turns codec steps
               into specks: cap at 1. Never set texture anisotropy (measured worse, 83.8 -> 126.6). */
            /* V9.28.211 (H585): blue-streak's shared roughness/metalness atlas has no UV padding at u 0.04/0.96 and drew a white seam
               across the band; each material's value is constant inside its island, so use the constants and drop the maps */
            if (lk.rough && (m.roughnessMap || m.metalnessMap) && !/logo/i.test(m.name || '')) { m.roughnessMap = null; m.metalnessMap = null; m.roughness = (m.name in lk.rough) ? lk.rough[m.name] : lk.rough['*']; m.metalness = 1; m.needsUpdate = true; }
            if (m.normalMap) { if (lk.nrm === 0) m.normalMap = null; else { var ns = Math.abs(m.normalScale.x); if (ns > 1) m.normalScale.multiplyScalar(1 / ns); } }
            if (!/logo/i.test(m.name || '')) { m.userData.base = { c: m.color.clone(), r: m.roughness }; body.push(m); }
            /* V9.28.199 (Shubham: "the logo must read silver on the silver ring"): a logo DECAL (texture = the metal's colour
               around white letters, e.g. vulcan's gold patch) gets its background swapped for the chosen metal in the shader;
               the white letters stay white. Off (unchanged) until a non-gold metal is picked on a follow ring. */
            else if (m.map) { var u = { value: [0, 0, 0, 0] }, uw = { value: 0 }, ue = { value: [0.25, 0.7] }; m.userData.logoU = u; m.userData.logoW = uw; m.userData.logoE = ue; logos.push(m);
              m.customProgramCacheKey = function () { return 'mes-logo-tint'; };
              m.onBeforeCompile = function (sh) { sh.uniforms.uLogoTint = u; sh.uniforms.uLogoWhite = uw; sh.uniforms.uLogoEdge = ue;
                /* V9.28.204 (Shrey 14 Oct, H577): on black the letters must read WHITE; a metallic white letter only mirrors the dark
                   studio, so with uLogoWhite the letter pixels become a matte white (metalness 0, rough 0.6) */
                sh.fragmentShader = 'uniform vec4 uLogoTint;\nuniform float uLogoWhite;\nuniform vec2 uLogoEdge;\n' + sh.fragmentShader
                  .replace('#include <map_fragment>', '#include <map_fragment>\n  float mesWh = 0.0;\n  if (uLogoTint.w > 0.5) { mesWh = smoothstep(uLogoEdge.x, uLogoEdge.y, min(diffuseColor.r, min(diffuseColor.g, diffuseColor.b))); diffuseColor.rgb = mix(uLogoTint.rgb, mix(diffuseColor.rgb, vec3(0.9), uLogoWhite), mesWh); }')
                  .replace('#include <metalnessmap_fragment>', '#include <metalnessmap_fragment>\n  metalnessFactor = mix(metalnessFactor, 0.0, mesWh * uLogoWhite);')
                  .replace('#include <roughnessmap_fragment>', '#include <roughnessmap_fragment>\n  roughnessFactor = mix(roughnessFactor, 0.6, mesWh * uLogoWhite);'); }; } });
        });
        g.userData.body = body; g.userData.logos = logos;
        return g;
      });
    }
    function applyTint() {
      if (!v || !v.ring) return;
      var mode = model.tint || 'none', key = mode === 'follow' ? metal : (mode in PAL ? mode : null), P = key ? PAL[key] : null;
      var lk = lookOf(v.src); if (P && lk.pal && lk.pal[key]) P = lk.pal[key]; v.r.toneMappingExposure = (mode === 'follow' && key && lk.metal && lk.metal[key]) || lk.exp || 1;
      /* follow + a colour the map does not know = the model's own materials (the design fell back to gold) */
      (v.ring.userData.logos || []).forEach(function (m) { var u = m.userData.logoU.value; if (P && mode === 'follow') { u[0] = P[0]; u[1] = P[1]; u[2] = P[2]; u[3] = 1; } else if (!P && lk.body) { u[0] = lk.body[0]; u[1] = lk.body[1]; u[2] = lk.body[2]; u[3] = 1; /* V9.28.208 (H583): an untinted ring's logo decal takes its body colour */ } else { u[3] = 0; } m.userData.logoW.value = (P && mode === 'follow' && key === 'black') ? 1 : 0; m.userData.logoE.value = lk.logoEdge || [0.25, 0.7]; });
      v.ring.userData.body.forEach(function (m) {
        var b = m.userData.base;
        if (P) { m.color.setRGB(P[0], P[1], P[2]); } else if (lk.mat && lk.mat[m.name]) { var mc = lk.mat[m.name]; m.color.setRGB(mc[0], mc[1], mc[2]); } else if (lk.body) { m.color.setRGB(lk.body[0], lk.body[1], lk.body[2]); } else if (b) { m.color.copy(b.c); }
        if (b) { m.roughness = b.r; } /* never replace roughness */
        m.needsUpdate = true;
      });
    }
    function build() {
      if (building) return building;
      var src = model.src;
      /* auto mode only: an idle slot between the heavy steps (bundle parse, GLB decode, renderer + studio), so a tap
         that lands mid-load is never stuck behind all three at once */
      function gap(x) { return pendingAuto ? new Promise(function (res) { (window.requestIdleCallback || function (f) { setTimeout(f, 50); })(function () { res(x); }, { timeout: 600 }); }) : x; }
      building = three(A('three', '')).then(gap).then(function (T) {
        var loader = new T.GLTFLoader().setMeshoptDecoder(T.MeshoptDecoder);
        return fetchModel(T, loader, src).then(function (ring) { return { T: T, loader: loader, ring: ring }; });
      }).then(gap).then(function (o) {
        return studioPixels(pendingAuto && !document.hidden).then(function (px) { o.px = px; return o; });
      }).then(function (o) {
        var T = o.T;
        if (!open) { freeTree(o.ring); building = null; return null; } /* closed while loading: drop it */
        var r = new T.WebGLRenderer({ antialias: true, alpha: true });
        r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.75));
        r.outputColorSpace = T.SRGBColorSpace; r.toneMapping = T.NeutralToneMapping; /* V9.28.198: Neutral keeps gold's saturation; AgX (as Blender) read washed out next to the product photos (Shrey) */ r.toneMappingExposure = 1.0;
        var cv = r.domElement; cv.setAttribute('aria-hidden', 'true'); cv.className = 'mes-r3d-cv';
        stage.appendChild(cv);
        var scene = new T.Scene();
        var pm = new T.PMREMGenerator(r), env = studio(T, o.px), envRT = pm.fromScene(env, 0); scene.environment = envRT.texture; pm.dispose(); freeTree(env);
        var cam = new T.PerspectiveCamera(30, 1, 0.01, 100); cam.position.set(0, 0.25, 4.4); cam.lookAt(0, -0.05, 0);
        var upright = new T.Group(); upright.add(o.ring);
        var spin = new T.Group(); spin.add(upright);
        var lift = new T.Group(); lift.add(spin); scene.add(lift);
        var rest = -0.22; lift.position.y = rest; cam.position.z = 5.1; /* hero: a touch lower and smaller */
        var c = document.createElement('canvas'); c.width = c.height = 128; var g = c.getContext('2d');
        var grd = g.createRadialGradient(64, 64, 4, 64, 64, 64); grd.addColorStop(0, 'rgba(0,0,0,.75)'); grd.addColorStop(1, 'rgba(0,0,0,0)');
        g.fillStyle = grd; g.fillRect(0, 0, 128, 128);
        var sh = new T.Mesh(new T.PlaneGeometry(2.2, 0.8), new T.MeshBasicMaterial({ map: new T.CanvasTexture(c), transparent: true, depthWrite: false }));
        sh.rotation.x = -Math.PI / 2; sh.position.y = rest - 0.82; scene.add(sh);
        v = { T: T, r: r, cv: cv, scene: scene, envRT: envRT, cam: cam, upright: upright, spin: spin, lift: lift, rest: rest, shadow: sh, ring: o.ring, loader: o.loader,
          rotY: -0.75, rotX: 0.32, /* three-quarter view: the band shows, as in the Blender renders */ vel: 0, touched: false, lt: 0, intro: RM.matches ? 0 : performance.now(), visible: true, w: 0, h: 0, src: src };
        spin.rotation.set(v.rotX, v.rotY, 0);
        if (v.intro) lift.position.y = rest + 1.1;
        applyTint();
        v.ro = new ResizeObserver(resize); v.ro.observe(stage); resize();
        v.io = new IntersectionObserver(function (es) { v && (v.visible = es[0].isIntersecting) && loop(); }); v.io.observe(layer);
        /* shaders compile off the main thread where the GPU allows it (KHR_parallel_shader_compile), before frame 1 */
        var vv = v, done = function () { building = null; return vv; };
        return r.compileAsync ? r.compileAsync(scene, cam).then(done, done) : done();
      }).then(null, function (e) { building = null; throw e; });
      return building;
    }
    function resize() {
      if (!v) return; var w = stage.clientWidth, h = stage.clientHeight; if (!w || !h || (w === v.w && h === v.h)) return;
      v.w = w; v.h = h; v.r.setSize(w, h, false); v.cam.aspect = w / h; v.cam.fov = w < h ? 38 : 30; v.cam.updateProjectionMatrix(); loop();
    }
    function loop() { if (raf || !v || !open || !v.visible || document.hidden) return; raf = requestAnimationFrame(frame); }
    function frame(t) {
      raf = 0; if (!v) return;
      var f = Math.min(2, v.lt ? (t - v.lt) / 16.667 : 1); v.lt = t; /* frame-rate independent: the design's per-frame constants at 60 fps */
      if (!v.touched && !RM.matches) v.vel += (IDLE - v.vel) * (1 - Math.pow(0.95, f));
      v.rotY += v.vel * f; v.vel *= Math.pow(0.94, f);
      v.spin.rotation.y = v.rotY; v.spin.rotation.x += (v.rotX - v.spin.rotation.x) * (1 - Math.pow(0.85, f));
      if (v.intro) { var k = Math.min(1, (t - v.intro) / 900), e = 1 - Math.pow(1 - k, 3); v.lift.position.y = v.rest + (1 - e) * 1.1; if (k >= 1) v.intro = 0; }
      v.cam.position.y = 0.25;
      var hgt = v.lift.position.y - v.rest, sc = Math.max(0.35, 1 - hgt * 0.5);
      v.shadow.scale.set(sc, sc, 1); v.shadow.material.opacity = Math.max(0.15, 1 - hgt * 0.7);
      v.r.render(v.scene, v.cam);
      if (!shown) { shown = true; requestAnimationFrame(function () { if (v) v.cv.classList.add('is-on'); }); }
      /* keep going while it spins on its own, coasts, settles its tilt or falls in; otherwise sleep until the next drag */
      var busy = (!v.touched && !RM.matches && IDLE > 0) || Math.abs(v.vel) > 1e-4 || v.intro || Math.abs(v.rotX - v.spin.rotation.x) > 1e-3;
      if (busy) loop();
    }
    function dispose() {
      cancelAnimationFrame(raf); raf = 0; shown = false;
      if (!v) return;
      v.ro && v.ro.disconnect(); v.io && v.io.disconnect();
      freeTree(v.scene); v.envRT && v.envRT.dispose();
      v.r.dispose(); try { v.r.forceContextLoss(); } catch (e) {}
      if (v.cv.parentNode) v.cv.parentNode.removeChild(v.cv);
      v = null;
    }

    /* ---------- drag to turn, with inertia (port of bindDrag; pointer capture so it never leaks to the carousel) ---------- */
    var down = null;
    layer.addEventListener('pointerdown', function (e) {
      if (!v) return; down = { x: e.clientX, y: e.clientY, t: performance.now() }; v.touched = true; v.drag = true;
      try { layer.setPointerCapture(e.pointerId); } catch (_) {}
      loop();
    });
    layer.addEventListener('pointermove', function (e) {
      e.stopPropagation(); /* the gallery's custom cursor listens on the wrapper */
      if (!down || !v) return;
      var dx = e.clientX - down.x, dy = e.clientY - down.y, now = performance.now();
      if (Math.abs(dx) > Math.abs(dy) || e.pointerType === 'mouse') {
        v.rotY += dx * 0.012; v.rotX = Math.max(-0.6, Math.min(0.8, v.rotX + dy * 0.006));
        v.vel = dx * 0.012 / Math.max(8, now - down.t) * 16;
      }
      down.x = e.clientX; down.y = e.clientY; down.t = now; loop();
    });
    function up() { down = null; if (v) { v.drag = false; loop(); } }
    layer.addEventListener('pointerup', up); layer.addEventListener('pointercancel', up);
    layer.addEventListener('click', function (e) { e.stopPropagation(); }); /* never reaches the carousel's click-to-advance */

    /* ---------- open / close ---------- */
    function reveal() {
      host.classList.add('mes-r3d-on'); place();
      if (!hostRO && window.ResizeObserver && !root.classList.contains('is-inline')) { hostRO = new ResizeObserver(place); hostRO.observe(host); }
      layer.hidden = false; void layer.offsetWidth; layer.classList.add('is-on');
      pill.setAttribute('aria-pressed', 'true');
    }
    function show() {
      open = true; pendingAuto = false; clearTimeout(closeT);
      reveal();
      if (v) { label(L.off); v.lt = 0; loop(); return; }
      label(L.loading || L.off); setNote(L.loading);
      build().then(function (vv) {
        if (!vv || !open) return;
        if (vv.src !== model.src) { dispose(); hide(); show(); return; } /* the colour changed to another model mid-load */
        setNote(''); label(L.off); loop();
      }).catch(function (err) {
        if (window.console) console.warn('[mes-r3d]', err);
        hide(); label(L.retry || L.on);
      });
    }
    function hide() {
      open = false; layer.classList.remove('is-on'); pill.setAttribute('aria-pressed', 'false'); label(L.on); setNote('');
      if (hostRO) { hostRO.disconnect(); hostRO = null; }
      clearTimeout(closeT);
      closeT = setTimeout(function () { if (open) return; dispose(); layer.hidden = true; host.classList.remove('mes-r3d-on'); }, FADE + 50);
    }
    pill.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); userTook = true; if (open && !pendingAuto) hide(); else show(); });

    /* ---------- auto mode: load hidden, fade in only a ready ring ---------- */
    var lastIn = 0;
    ['pointerdown', 'keydown'].forEach(function (t) { window.addEventListener(t, function () { lastIn = performance.now(); }, { capture: true, passive: true }); });
    function autoShow() {
      if (open || userTook || document.hidden) return;
      if (performance.now() - lastIn < 1000) { setTimeout(autoShow, 500); return; } /* never start mid-tap */
      if (host.querySelector('.mes-lv-layer.is-on')) return; /* the lead video owns this photo */
      open = true; pendingAuto = true;
      build().then(function (vv) {
        if (!pendingAuto) return; /* tapped meanwhile: show() owns it now */
        pendingAuto = false;
        if (!vv || !open) return;
        if (vv.src !== model.src) { open = false; dispose(); return; }
        reveal(); label(L.off); loop();
      }).catch(function () { pendingAuto = false; open = false; });
    }
    (function armAuto() {
      var mode = A('auto', 'tap'), n = navigator, c = n.connection || {};
      if (mode === 'tap' || root.classList.contains('is-inline') || RM.matches || c.saveData === true) return;
      /* Apple devices: Safari exposes no deviceMemory and reports a capped core count, so the core test called every
         iPhone low-end (Priyanka 13 Oct: auto 3D on Android, never on iPhone). Every iPhone/iPad Safari runs this scene. */
      var apple = /iP(hone|ad|od)/.test(n.platform || '') || (n.platform === 'MacIntel' && n.maxTouchPoints > 1);
      var weak = (n.deviceMemory > 0 && n.deviceMemory <= 4) || (!apple && n.hardwareConcurrency > 0 && n.hardwareConcurrency <= 4);
      if (mode === 'capable' && weak) return;
      var delay = parseInt(A('auto-delay', '1000'), 10) || 0;
      function watch() {
        if (userTook || open) return;
        if (!('IntersectionObserver' in window)) { autoShow(); return; }
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); autoShow(); } }, { threshold: 0.5 });
        io.observe(host);
      }
      function go() { setTimeout(function () { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(watch, { timeout: 2000 }); }, delay); }
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    })();

    /* ---------- another photo chosen (dots, thumbnails): back to the photos ---------- */
    var scroller = root.classList.contains('is-inline') ? null : host.querySelector('.product-gallery__media-list'), sq = 0;
    if (scroller) scroller.addEventListener('scroll', function () {
      if (!open || pendingAuto || sq) return;
      sq = requestAnimationFrame(function () {
        sq = 0; if (!open || pendingAuto || !atSlide) return;
        if (current(host.getBoundingClientRect()) !== atSlide) hide(); else place(); /* same photo settling (snap): follow it */
      });
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { if (v) v.lt = 0; loop(); } });

    /* ---------- tint (and, for product-media models, the model) follow the selected variant ---------- */
    document.addEventListener('variant:change', function (e) {
      var vr = e.detail && e.detail.variant; if (!vr) return;
      var m2 = metalOf(map, vr.options), a2 = (vr.featured_image && vr.featured_image.alt) || (vr.featured_media && vr.featured_media.alt) || alt;
      var changed = m2 !== metal; metal = m2; alt = a2;
      var next = pick();
      if (next.src !== model.src) {
        model = next;
        if (v) { dispose(); if (open) { setNote(L.loading); build().then(function (vv) { if (vv && open) { setNote(''); loop(); } }).catch(function () { hide(); label(L.retry || L.on); }); } }
        return;
      }
      model = next;
      if (changed && v) { applyTint(); if (!RM.matches) v.vel += 0.08; loop(); }
    }, true);
    /* leaving the page (or entering the back/forward cache): back to the photo, nothing kept alive */
    window.addEventListener('pagehide', function () {
      open = false; pendingAuto = false; clearTimeout(closeT); dispose(); layer.classList.remove('is-on'); layer.hidden = true;
      host.classList.remove('mes-r3d-on'); pill.setAttribute('aria-pressed', 'false'); label(L.on); setNote('');
      if (hostRO) { hostRO.disconnect(); hostRO = null; }
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mes-r3d]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-mes-r3d]'); if (r) init(r); });
})();
